module.exports = __webpack_public_path__ + "static/media/bx2.7d355686.png";